<div
  bsDropdown
  class="gcc-select dropdown"
  [isDisabled]="disabled"
  [isOpen]="isOpen"
  (isOpenChange)="handleDropdownToggle($event)"
>
  <button dropdownToggle type="button" class="form-control text-left dropdown-toggle d-flex align-items-center">
    @if (empty) {
      <span class="placeholder text-gray flex-grow-1">{{ placeholder || '\u00A0' }}</span>
    } @else {
      <div class="flex-grow-1 d-flex">
        @for (value of triggerValue; track value) {
          <span class="mr-1" [innerHTML]="value"></span>
        }
      </div>
    }
  </button>
  <div *dropdownMenu class="dropdown-menu">
    <ng-content></ng-content>
  </div>
</div>
